import { PREQUAL_ROUTE_PATH } from '../constants';

/**
 * The Pre-Qual landing page is served directly under a partner's own host
 * (e.g. BoatTrader proxies it at /boat-loans/apply/prequal), not from this
 * app's root, so the raw browser pathname is prefixed by that partner's
 * basePath. Match on suffix/segment rather than anchoring to the start.
 */
export const isPrequalPath = (pathname: string): boolean =>
  pathname.endsWith(PREQUAL_ROUTE_PATH) || pathname.includes(`${PREQUAL_ROUTE_PATH}/`);
